import { render, staticRenderFns } from "./ProjectSection.vue?vue&type=template&id=58868ac9&scoped=true&"
import script from "./ProjectSection.vue?vue&type=script&lang=ts&"
export * from "./ProjectSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSection.vue?vue&type=style&index=0&id=58868ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58868ac9",
  null
  
)

export default component.exports